import React from "react";

import { message, Popover, Row, Col } from "antd";

import { Link, Switch, Route } from "react-router-dom";
import { SessionStore, LocaleStore, RouterStore, PriceStore } from "../../stores";
// import { SessionStore, LocaleStore, RouterStore,PriceStore } from "@/stores";
import { inject, observer } from "mobx-react";
import "./index.less";
import { locale } from "moment";
import MyIcon from "../MyIcon";
import { CoinHelper } from "@/utils";

export interface Props {
  session: SessionStore;
  router: RouterStore;
  locale: LocaleStore;
  price: PriceStore;
}

@inject("session", "locale", "router", "price")
@observer
class CompareEarn extends React.Component<Props, any> {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    const { price, session } = this.props;
    session.coinEarn();
    price.getDayEarn();
  }

  state = {};

  render() {
    const { locale, price, session } = this.props;
    const { moneyFlag, bsvCoinProfit, btcCoinProfit, bsvLegacyProfit, btcLegacyProfit } = price;
    const heigherType = session.bsvHeigher ? "BSV" : "BTC";
    const heigherRate = session.bsvHeigher
      ? (
          ((parseFloat(session.coinEarnData.bsv_earn) -
            parseFloat(session.coinEarnData.btc_earn_tran)) /
            parseFloat(session.coinEarnData.btc_earn_tran)) *
          100
        ).toFixed(2) + " %"
      : (
          ((parseFloat(session.coinEarnData.btc_earn) -
            parseFloat(session.coinEarnData.bsv_earn_tran)) /
            parseFloat(session.coinEarnData.bsv_earn_tran)) *
          100
        ).toFixed(2) + " %";
    const tip = locale.isEqualToDefaultLocale
      ? `${locale.get("fund.Current")}${heigherType}
    ${locale.get("fund.moreHeigher")}
    ${locale.get("WithDraw.height")}
    ${heigherRate}`
      : `${heigherType} ${locale.get("fund.better")}${heigherRate}${locale.get(
          "fund.moreHeigher"
        )}`;

    return (
      <section className="compare-earn">
        <Row className="block" justify="space-between">
          <Col span={6} className="block-left">
            {tip}
          </Col>
          <Col span={8} className="block-flex">
            <div className="block-right">
              <MyIcon type="icon-btc" className="icon-btc" /> BTC
            </div>
            <div>{`${btcCoinProfit.toFixed(8)} BTC/T ≈ ${btcLegacyProfit.toFixed(
              3
            )} ${moneyFlag}/T`}</div>
          </Col>
          <Col span={8} className="block-flex">
            <div className="block-right">
              <MyIcon type="icon-bsv" className="icon-bsv" /> BSV
            </div>
            <div>{`${bsvCoinProfit.toFixed(8)} BSV/T ≈ ${bsvLegacyProfit.toFixed(
              3
            )} ${moneyFlag}/T`}</div>
          </Col>
        </Row>
      </section>
    );
  }
}

export default CompareEarn as React.ComponentType;
